unit DisposableItemType;
{

/* Initial. */

}

interface

type
  TDisposableItemType = class
  private
    fDisposableKey: String;
    fName: String;
    fSupplierName: String;
    fTypeName: String;
    fOrderNumber: String;
    fActive: Boolean;
  public
    property DisposableKey: String read fDisposableKey;
    property Name: String read fName;
    property SupplierName: String read fSupplierName;
    property TypeName: String read fTypeName;
    property OrderNumber: String read fOrderNumber;
    property Active: Boolean read fActive;
  end;

implementation

end.
